import React from 'react';
import styled from 'styled-components';

interface WarningModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const WarningModal: React.FC<WarningModalProps> = ({
  isOpen,
  message,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>알림</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <ModalBody>
          <Message>{message}</Message>
        </ModalBody>
        <ModalFooter>
          <ConfirmButton onClick={onClose}>
            확인
          </ConfirmButton>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

export default WarningModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
`;

const ModalContent = styled.div`
  background: var(--color-surface);
  border-radius: 12px;
  padding: 0;
  box-shadow: var(--modal-shadow-large);
  width: 90%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  border: var(--modal-border);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--color-border);
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-text-primary);
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-panel);
    color: var(--color-text-primary);
  }
`;

const ModalBody = styled.div`
  padding: 24px;
  flex: 1;
  overflow-y: auto;
`;

const Message = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: var(--color-text-primary);
  white-space: pre-line;
`;

const ModalFooter = styled.div`
  display: flex;
  padding: 20px 24px;
  border-top: 1px solid var(--color-border);
  justify-content: flex-end;
`;

const ConfirmButton = styled.button`
  padding: 12px 24px;
  background: var(--color-accent-strong);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-accent);
    transform: translateY(-1px);
    box-shadow: var(--modal-shadow);
  }

  &:active {
    transform: translateY(0);
  }
`;

